import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';

const LegalPage = ({ documentType }) => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState('');

  useEffect(() => {
    const fetchContent = async () => {
      setLoading(true);
      let fileName;
      let pageTitle;
      
      switch (documentType) {
        case 'terms':
          fileName = 'terms.md';
          pageTitle = 'Terms of Service';
          break;
        case 'privacy':
          fileName = 'privacy.md';
          pageTitle = 'Privacy Policy';
          break;
        case 'user-agreement':
          fileName = 'user-agreement.md';
          pageTitle = 'User Agreement';
          break;
        default:
          fileName = 'terms.md';
          pageTitle = 'Terms of Service';
      }
      
      try {
        const response = await fetch(`/markdown/${fileName}`);
        const text = await response.text();
        setContent(text);
        setTitle(pageTitle);
      } catch (error) {
        console.error('Error loading markdown file:', error);
        setContent('# Error\n\nUnable to load the requested document.');
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, [documentType]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="bg-white shadow-md rounded-lg p-6 md:p-8">
        <h1 className="text-2xl font-bold mb-6 text-gray-800">{title}</h1>
        <div className="prose max-w-none">
          <ReactMarkdown>{content}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
